export default __webpack_public_path__ + "static/media/fingersCross.5dc42582.svg";